import NumberComponent from '../number';

class CurrencyComponent extends NumberComponent {
  constructor (component, data) {
    super(component, data);
  }
}

export default CurrencyComponent;
